import { observer } from 'mobx-react-lite';

import CategoryBlock, {
  CategoryDisplayType,
} from '~/components/CategoryBlocks/CategoryBlock';
import CategoryBlockErrorBoundary from '~/components/CategoryBlocks/CategoryBlockErrorBoundary';
import type { Category } from '~/stores/CategoriesStore';

import { StatsCardDE } from './StatsCardDE';
import { TrustRowDE } from './TrustRowDE';

interface Props {
  category: Category;
}

const renderBlock = (category: Category) => {
  switch (category.displayType) {
    case CategoryDisplayType.DE_TRUST_ROW:
      return <TrustRowDE category={category} />;
    case CategoryDisplayType.DE_STATS_CARD:
      return <StatsCardDE category={category} />;
    default:
      return (
        <CategoryBlock
          category={category}
          externalLink={category.externalLink ?? undefined}
        />
      );
  }
};

/**
 * One home block of the DubaiExpress main page, picked by the display type
 * set in the CMS: the two DubaiExpress-only blocks here, everything else
 * (the compact marketplace blocks included) through the shared block factory. Each block is isolated like the shared ones, so a
 * broken CMS entry cannot take the whole home page down.
 */
const HomeBlockDEView = ({ category }: Props) => (
  <CategoryBlockErrorBoundary parent={category.displayType ?? 'unknown'}>
    {renderBlock(category)}
  </CategoryBlockErrorBoundary>
);

export const HomeBlockDE = observer(HomeBlockDEView);
